/* eslint-disable react-hooks/exhaustive-deps */
import React, { Suspense, useLayoutEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import classes from "./index.module.scss";
import { isAuthenticated } from "helper";
import ToolBar from "components/ToolBar";
import SideMenu from "components/OnboardingSideMenu";
import { FullLoader } from "components/Loader";
import { useOnahDispatch, useOnahSelector } from "store/hooks";
import { getUserProfile } from "store/slices/user";
import { checkOnboardingStatus } from "store/slices/onboarding";
import { useMediaQuery } from "hooks/useMediaQuery";

type Props = {};

const OnboardingLayout = (props: Props) => {
  const dispatch = useOnahDispatch();
  const {pathname} = useLocation();
  const {completionPercentage} = useOnahSelector(state => state.onboarding);
  let isTablet = useMediaQuery("(max-width: 1024px)", window.innerWidth <= 1024);
  const [open, setOpen] = useState(isTablet ? false : true);

  useLayoutEffect(() => {
    if (isAuthenticated()) {
      dispatch(getUserProfile());
      dispatch(
        checkOnboardingStatus({})
      )
    }
  }, [pathname]);

  return (
    <div className={classes.main__layout}>
      <ToolBar progress={completionPercentage} setOpen={setOpen} />
      <div className={classes.layout__body}>
        <SideMenu 
          className="!fixed lg:!sticky top-0"     
          open={open}
          setOpen={setOpen}
          isTablet={isTablet}
        />
        <div className={classes.layout__outlet}>
          <div className="bg-white rounded-[32px] max-2xl:rounded-xl pt-[56px] max-2xl:pt-[36px] px-8 pb-5 mb-5 min-h-[calc(100%-1.25rem)]">
            <div className="w-[100%] max-w-[848px] max-2xl:max-w-[548px] mx-auto">
              <Suspense fallback={<FullLoader className="!h-[calc(100%-1.25rem)]"/>}>
                <Outlet />
              </Suspense>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OnboardingLayout;
